interface ProgressBarProps {
  progress: number;
}

export const ProgressBar = ({ progress }: ProgressBarProps) => {
  return (
    <div className="flex h-1 w-full rounded-full bg-gray-300">
      <div
        // TODO: если h-1 очень плохо видно скругление
        className="h-1 rounded-full bg-[#3179FF]"
        style={{ width: `${progress + 2}%` }}
      ></div>
      <div
        className="absolute -translate-y-1/4 translate-x-1 px-8"
        style={{ left: `${progress * 2}px` }}
      >
        <div className="flex h-2 w-2 items-center justify-center rounded-full border-2 border-blue-600 bg-blue-600 bg-textColor text-blue-600 shadow-lg"></div>
      </div>
    </div>
  );
};
